<template>
	<div class="copy-right-intro">
		<h2 data-aos="fade-in">版权介绍</h2>
		<h3 data-aos="fade-up">版权业务<small>COPYRIGHT  BUSSINESS</small></h3>
		<div class="copy-right-intro.img" data-aos="fade-up">
			<img src="../assets/trademarks/copy-intro.png" alt="">
		</div>
		<h3 data-aos="fade-up">版权疑难杂症<small>COPYRIGHT  BUSSINESS  FAQ</small></h3>
		<ul>
			<li v-for="(question,index) in questions" :key="index" data-aos="fade-up">
				<p><span>Q</span>{{question.q}}</p>
				<p><span>A</span>{{question.a}}</p>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				questions:[
					{
						q:'版权认证与商标注册的区别？',
					    a:'相比于商标注册，版权认证花的时间短，可以先期把版权权利固定下来，如果有人提前抢注，可以以版权对抗商标权，宣告抢注的商标权利无效'
					},
					{
						q:'版权保护的期限是多长？',
						a:'版权保护期限，个人自其作品创作完成之日起，至作者死后第50年的12月31日止。法人或其他组织作品自该作品发表之日起，到发表之日后第50年12月31日止。作品始终没有发表的，自作品创作完成的50年内未发表的，著作权法不再保护。'
					},
					{
						q:'哪些作品可以获得版权保护？',
						a:'我国著作权法第三条规定的各类作品均可申请登记。包括：文字作品；口述作品；音乐、戏剧、曲艺、舞蹈、杂技艺术作品；美术、建筑作品；摄影作品；电影作品和以类似摄制电影的方法创作的作品；工程设计图、产品设计图、地图、示意图等图形作品和模型作品；计算机软件；法律、行政法规规定的其他作品。'
					},
					{
						q:'哪些人可以成为软件著作权人？',
						a:'独立开发完成软件的自然人、法人或其他组织以及通过合同约定、集成、受让或者承受软件著作权的自然人、法人或者其他组织都可以成为著作权人。'
					},
					
					
				]
			}
		}
	}
</script>

<style lang="scss">
	@include component(copy-right-intro){
		width: 1200px;
		margin: 0 auto;
		margin-top: 20px;
		background:rgba(255,255,255,1);
		box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.1);
		padding: 38px 30px;
		color: #333333;
		font-size: 16px;
		>h2{
			font-size:24px;
			font-weight:bold;
			color:#F47227;
			line-height:30px;
			margin: 0;
			text-align: left;
			border-bottom: 1px solid #F2F2F2;
			padding-bottom: 20px;
			position: relative;
			&:before{
				display: inline-block;
				content: '';
			    width: 100px;
				height: 5px;
				background:#F47227 ;
				position: absolute;
				bottom: 0;
				left: 0;
			}
		}
		>h3{
			margin: 0;
			margin-top: 50px;
			font-size:24px;
			font-weight: 400;
			small{
				display: block;
				font-size:14px;
				color: #999999;
				margin-top: 10px;
			}
		}
		@include part(img){
			margin-top: 30px;
			display:flex;
			justify-content: center;
			img{
				display: block;
			}
			
		}
		>ul{
			margin-top: 30px;
			li{
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				border-bottom: 1px dashed #CCCCCC;
				padding-bottom: 20px;
				justify-content: center;
				&:not(:nth-child(1)){
					margin-top: 20px;
				}
			}
			p{
				text-align: left;
				position:relative;
				padding-left:40px;
				line-height: 30px;
				span{
					display: inline-block;
					width: 28px;
					height: 28px;
					background-color: #2278FC;
					border-radius:50%;
					text-align: center;
					line-height: 28px;
					color: #FFFFFF;
					font-weight: bold;
					position: absolute;
					left: 0;
					top: 0;
				}
				&:nth-child(1){
					margin-bottom:15px;
					color:#999999;
					span{
						background: #f47227 ;
					}
				}
			}
		}
	}
</style>
